
























import { Vue, Component, Prop } from 'vue-property-decorator';
import EnumObject from '@/domain/enum-object.entity';

@Component
export default class StrategyRadioComponent extends Vue {
  @Prop({ type: String, required: true }) value!: string;

  @Prop({ type: Boolean, required: true }) isEditMode!: boolean;

  @Prop({ type: Array, default: true }) strategies!: Array<EnumObject>;

  emitChange(value: string): void {
    this.$emit('change', value);
  }
}
